import { render, staticRenderFns } from "./RiskRelated.vue?vue&type=template&id=5ffcb20e&scoped=true"
import script from "./RiskRelated.vue?vue&type=script&lang=js"
export * from "./RiskRelated.vue?vue&type=script&lang=js"
import style0 from "./RiskRelated.vue?vue&type=style&index=0&id=5ffcb20e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffcb20e",
  null
  
)

export default component.exports